import styled from 'styled-components';
import { buttonBase } from '../styled';
import { getToggleButtonAppearance, getIconButtonSize } from '../utils';
import { iconButtonBase } from '../utils/getToggleButtonAppearance';
export const IconToggleButtonContainer = styled.button `
  ${buttonBase}
  ${iconButtonBase}

  ${(props) => getToggleButtonAppearance(props.$appearance, props.$toggled)};
  ${(props) => getIconButtonSize(props.size)};
`;
